import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Frequently Asked <span className="text-primary-600">Questions</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Everything you need to know about the Basetao Spreadsheet and how to make the most of it.
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIdx === idx ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}